import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
  { value: 0, label: "Em digitação" },
  { value: 1, label: "Aguardando análise" },
  { value: 2, label: "Revisar solicitação" },
  { value: 4, label: "Fiscalização solicitada" },
  { value: 5, label: "Atualização MIG pendente" },
  { value: 6, label: "Concluído" },
  { value: 7, label: "Cancelada" },
  { value: 8, label: "Arquivada" }
];

const SituacaoSolicFiscalizacao = ({ field, placeholder, name, id, disabled = false }) => {
  return (
    <Select
      options={options}
      {...field}
      styles={SearchFieldStyles}
      placeholder={placeholder}
      name={name}
      isDisabled={disabled}
      id={id}
    />
  )
}

export { SituacaoSolicFiscalizacao, options as OpcoesSituacaoSolicFiscalizacao }